import EstablishmentMutationProvider from '@establishment/contexts/establishmentMutationContext';
import EstablishmentForm from './EstablishmentForm';

const CreateEstablishmentPage = () => {
  return (
    <EstablishmentMutationProvider>
      <EstablishmentForm mode="create" />
    </EstablishmentMutationProvider>
  );
};

export default CreateEstablishmentPage;
